export const wordlyDummyData = [
  {
        "User_Rank": 1,
        "msisdn": "1946392517",
        "score": 60,
        "time_taken": 128,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 79,
        "win": 1,
        "name": "",
        "username": "1946392517",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 2,
        "msisdn": "1939136210",
        "score": 60,
        "time_taken": 129,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 79,
        "win": 1,
        "name": "",
        "username": "1939136210",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 3,
        "msisdn": "1939523000",
        "score": 60,
        "time_taken": 135,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 79,
        "win": 1,
        "name": "",
        "username": "1939523000",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 4,
        "msisdn": "1926051722",
        "score": 60,
        "time_taken": 136,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 79,
        "win": 1,
        "name": "",
        "username": "1926051722",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 5,
        "msisdn": "1972917498",
        "score": 60,
        "time_taken": 141,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 79,
        "win": 1,
        "name": null,
        "username": "1972917498",
        "avatar_id": 6,
        "avatar_img": ""
    }
]

export const memoryMatchDummyData = [
    {
        "id": 17212,
        "user_id": null,
        "msisdn": "19732917498",
        "total_time": 16,
        "round_number": 6,
        "event_id": 151,
        "portal_id": 18,
        "useragent": "Mozilla/5.0 (Linux; Android 14; 23021RAAEG Build/UKQ1.230917.001; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/141.0.7390.119 Mobile Safari/537.36 [FB_IAB/FB4A;FBAV/536.0.0.46.77;IABMV/1;]",
        "domain": "https://wordly.quizard.live/",
        "origin": "https://wordly.quizard.live",
        "difficulty_level": "easy",
        "created_at": "2025-10-27T09:58:57.295492",
        "updated_at": "2025-10-27T09:58:57.295521",
        "ranked_order": 1,
        "user_rank": 1
    },
    {
        "id": 17227,
        "user_id": null,
        "msisdn": "19537552295",
        "total_time": 19,
        "round_number": 3,
        "event_id": 151,
        "portal_id": 18,
        "useragent": "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Mobile Safari/537.36",
        "domain": "https://wordly.quizard.live/",
        "origin": "https://wordly.quizard.live",
        "difficulty_level": "easy",
        "created_at": "2025-10-27T16:47:43.923379",
        "updated_at": "2025-10-27T16:47:43.923404",
        "ranked_order": 1,
        "user_rank": 2
    },
    {
        "id": 17223,
        "user_id": null,
        "msisdn": "19302134487",
        "total_time": 40,
        "round_number": 1,
        "event_id": 151,
        "portal_id": 18,
        "useragent": "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/141.0.0.0 Mobile Safari/537.36",
        "domain": "https://wordly.quizard.live/",
        "origin": "https://wordly.quizard.live",
        "difficulty_level": "easy",
        "created_at": "2025-10-27T12:18:23.528796",
        "updated_at": "2025-10-27T12:18:23.528823",
        "ranked_order": 1,
        "user_rank": 3
    },
    {
        "id": 17218,
        "user_id": null,
        "msisdn": "19718151157",
        "total_time": 41,
        "round_number": 2,
        "event_id": 151,
        "portal_id": 18,
        "useragent": "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/141.0.0.0 Mobile Safari/537.36",
        "domain": "https://wordly.quizard.live/",
        "origin": "https://wordly.quizard.live",
        "difficulty_level": "easy",
        "created_at": "2025-10-27T11:52:51.112010",
        "updated_at": "2025-10-27T11:52:51.112032",
        "ranked_order": 1,
        "user_rank": 4
    },
    {
        "id": 17201,
        "user_id": null,
        "msisdn": "19618238312",
        "total_time": 103,
        "round_number": 1,
        "event_id": 151,
        "portal_id": 18,
        "useragent": "Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/141.0.0.0 Mobile Safari/537.36",
        "domain": "https://wordly.quizard.live/",
        "origin": "https://wordly.quizard.live",
        "difficulty_level": "easy",
        "created_at": "2025-10-27T05:11:32.704297",
        "updated_at": "2025-10-27T05:11:32.704316",
        "ranked_order": 1,
        "user_rank": 5
    }
]

export const spellingBeeDummyData = [{
        "User_Rank": 1,
        "msisdn": "19646392517",
        "score": 60,
        "time_taken": 180,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 134,
        "win": 1,
        "name": "",
        "username": "19646392517",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 2,
        "msisdn": "19839523000",
        "score": 60,
        "time_taken": 180,
        "round_number": 2,
        "date": "2025-10-27",
        "event_id": 134,
        "win": 1,
        "name": "",
        "username": "19839523000",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 3,
        "msisdn": "1939136210",
        "score": 60,
        "time_taken": 180,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 134,
        "win": 1,
        "name": "",
        "username": "1939136210",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 4,
        "msisdn": "19887794424",
        "score": 60,
        "time_taken": 180,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 134,
        "win": 1,
        "name": "",
        "username": "19887794424",
        "avatar_id": null,
        "avatar_img": ""
    },
    {
        "User_Rank": 5,
        "msisdn": "19732917498",
        "score": 60,
        "time_taken": 180,
        "round_number": 1,
        "date": "2025-10-27",
        "event_id": 134,
        "win": 1,
        "name": null,
        "username": "19732917498",
        "avatar_id": 6,
        "avatar_img": ""
    }]
